import numeral from "numeral";
import { DMath } from "./DMath";
import Decimal from "decimal.js";

export function fNumber(number: any) {
  return numeral(number).format();
}

export function fPercent(number: any) {
  const format = number ? numeral(Number(number) / 100).format("0.0%") : "";
  return result(format, ".0");
}

export function fShortenNumber(number: any) {
  const format = number ? numeral(number).format("0.00a") : "";
  return result(format, ".00");
}

export function fData(number: any) {
  const format = number ? numeral(number).format("0.0 b") : "";
  return result(format, ".0");
}

export function fPercentage(part: any, total: any) {
  // return DMath.toFixed(DMath.div(DMath.mul(100, partialValue), totalValue));
  if (DMath.eq(total, 0)) return "0"; // avoid division by zero
  return DMath.toFixed(DMath.mul(DMath.div(part, total), 100));
}

export function fPercentageOf(num: any, per: any) {
  // return DMath.toFixed(DMath.mul(DMath.div(num, 100), per));
  return DMath.toFixed(DMath.mul(num, DMath.div(per, 100)));
}

// export function toFixed(num: number, digit: number = 2) {
//   let result = num.toFixed(digit);
//   if (result.indexOf(".00")) {
//     result = result.replace(".00", "");
//   }
//   return result;
// }

export function groupBy(data: any, f: any) {
  return data.reduce(
    (r: any, v: any, i: any, a: any, k = f(v)) => (
      (r[k] || (r[k] = [])).push(v), r
    ),
    {}
  );
  // return data.reduce((acc: any, obj: any) => {
  //     const property = obj[key];
  //     if (!acc[property]) {
  //       acc[property] = [];
  //     }
  //     acc[property].push(obj);
  //     return acc;
  //   }, {});
}

export function sum(data: any, key: string) {
  return DMath.toFixed(
    data.reduce((accumulator: Decimal, s: any) => {
      return DMath.add(accumulator, s[key]);
    }, DMath.toDecimal(0))
  );
}

function result(format: any, key = ".00") {
  const isInteger = format.includes(key);
  return isInteger ? format.replace(key, "") : format;
}

export function toInt(input: any, min: number = 0) {
  const output = parseInt(input.toString());
  if (isNaN(output) || output <= min) {
    return min;
  } else {
    return output;
  }
}

// export function toFloat(input: any, min: number = 0) {
//   const output = parseFloat(input.toString());
//   if (isNaN(output) || output <= min) {
//     return min;
//   } else {
//     return output;
//   }
// }

// export function roundToTwo(num: any) {
//   if (typeof num !== "number") {
//     if (num && num.length > 0 && !isNaN(num)) {
//       num = +num;
//     } else {
//       return 0;
//     }
//   }
//   // @ts-ignore
//   return +(Math.round(num + "e+2") + "e-2");
// }

export function countDecimals(num: number | string) {
  // if (!Number.isFinite(num)) return 0; // Handle non-finite numbers
  const str = num.toString();
  if (str.includes(".")) {
    return str.split(".")[1].length;
  }
  return 0;
}

// export const getOnlyNumbers = (str: string) => str.replace(/\D/g, "");
export const getOnlyNumbers = (str: string) => {
  const cleaned = str
    .replace(/[^0-9.]/g, "") // remove non-digit & non-dot
    .replace(/(\..*)\./g, "$1"); // prevent multiple dots
  return cleaned;
};

export function getShortUUID() {
  return Math.floor(new Date().valueOf() * Math.random()).toString();
}
